import { get as areaGet } from '../../apiv2';

async function fetchArea(cursor, range = 500, excludeSoft = false) {
  const softExclude = excludeSoft ? 1 : 0;
  const url = cursor
    ? `api/management/v2/areas?limit=${range}&cursor=${cursor}&excludeSoft=${softExclude}&filters[]=isActive:=1`
    : `api/management/v2/areas?limit=${range}&excludeSoft=${softExclude}&filters[]=isActive:=1`;
  try {
    const { data } = await areaGet(url);
    return data;
  } catch (e) {
    console.error('fetchLocations fail:', e);
  }
}

async function fetchAreas(range = 500, excludeSoft = false) {
  let areas = [];
  let cursor;
  let res;
  do {
    res = await fetchArea(cursor, range, excludeSoft);
    cursor = res?.nextCursor;
    areas = [...areas, ...(res?.data || [])];
  } while (cursor);
  return areas;
}

/**
 * fetchManagedAreas
 *
 * @param {Integer} employeeId
 * @param {Object} options Additional options
 * @param {Object} options.full Returns all the api details in full, if set to false, return only the area ids
 * @return {Array} Collection of area IDs or area details
 */
async function fetchManagedAreas(employeeId, options = { full: true }) {
  const url = `api/management/v2/areas-management?employeeId=${employeeId}`;
  try {
    const { data } = await areaGet(url);
    if (!options.full) {
      return data?.data?.map(area => area.areaId) || [];
    }
    return data;
  } catch (e) {
    console.error('fetchManagedAreas fail:', e);
  }
}

export { fetchAreas, fetchManagedAreas };
